import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPrimaryMemberCard } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Button } from '../../../subcomponents/button/button';
import { Modal } from '../../../subcomponents/modal/modal';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberCard } from '../card/member-card';
import { defaultMemberViewCardButtonProps, memberViewCardButtonPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-view-card-button');
export const MemberViewCardButton = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText, config, cdnOptions } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { member } = useMemberContext();
    if (!member)
        return enableSkeletonLoadingIndicators ? _jsx(MemberViewCardButtonSkeleton, {}) : null;
    const primaryCard = getPrimaryMemberCard();
    if (!primaryCard)
        return null;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(Button, { className: b.element('button'), label: displayText.label, color: config.color, size: config.size, onClick: () => setIsModalOpen(true) }), _jsx(Modal, Object.assign({ className: b.element('modal'), anchoredToTop: true, show: isModalOpen, onClose: () => setIsModalOpen(false) }, { children: _jsx(MemberCard, { displayText: displayText, config: config, cdnOptions: cdnOptions }) }))] })));
});
MemberViewCardButton.displayName = 'MemberViewCardButton';
export const MemberViewCardButtonSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
MemberViewCardButtonSkeleton.displayName = 'MemberViewCardButtonSkeleton';
/**
 * The **Member View Card Button** component renders a button that opens the **Member Card** component inside a modal.
 *
 * If the currently logged-in member does not have a primary card, the **Member View Card Button** component will not render.
 */
export const MemberViewCardButtonComponent = withComponentWrapper(MemberViewCardButton, defaultMemberViewCardButtonProps, memberViewCardButtonPropsValidator);
